import React from 'react';

// responsible for determining if it's inline form or not
// *********************************************************************************
class InlineFormWrapper extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      shouldHaveInlineForm: this.props.shouldHaveInlineForm
    }
  }

  render() {
    if (this.state.shouldHaveInlineForm) {
      return (
        <form action={`/member/${this.props.memberId}.js`}>
          {this.props.children}
        </form>
      );
    } else {
      return (this.props.children);
    }
  }
}

export default InlineFormWrapper;
